import { Avatar, Button, Card, CardActions, CardHeader, CardMedia } from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import { Controller, useFormContext } from "react-hook-form";
import { ApplicationMimeTypesEnum } from "../../../common/enums/ApplicationMimeTypesEnum";
import { IAttachment } from "../../../common/models/IAttachment";
import { getAttachmentUrl } from "../../../common/utilities/AttachmentHelpers";
import FormInput from "../form-input/FormInput";
import { FormFieldPropsBase } from "../form/Form";
import { useTranslation } from "react-i18next";

export enum FormAttachmentActionCardEnum {
    View = 1,
    Download = 2,
    Delete = 3
}

export type FormAttachmentCardProps = FormFieldPropsBase & {
    index: number;
    onAction?: (action: FormAttachmentActionCardEnum, index: number, attachment: IAttachment) => void;
};

export default function FormAttachmentCard({
    name,
    id,
    readOnly,
    disabled,
    index,
    onAction
}: FormAttachmentCardProps
) {

    const { control } = useFormContext();
    const { t } = useTranslation();

    return (
        <Controller
            control={control}
            name={name}
            render={
                ({
                    field: { ref, name, value, onChange, onBlur },
                    fieldState: { invalid, isTouched, isDirty, error },
                    formState
                }: {
                    field: any;
                    fieldState: any;
                    formState: any;
                }) => (
                    <Card
                        id={id}
                        sx={{
                            maxWidth: 345,
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1
                        }}
                        raised={true}
                    >
                        <CardHeader
                            title={value.fileName}
                            avatar={
                                <Avatar aria-label="File Name">
                                    <AttachFile />
                                </Avatar>
                            }
                            sx={{
                                padding: 1
                            }}
                            slotProps={{
                                title: {
                                    variant: "body2"
                                }
                            }}
                        />

                        {(value.mimeType === ApplicationMimeTypesEnum.JPEG ||
                            value.mimeType === ApplicationMimeTypesEnum.PNG ||
                            value.mimeType === ApplicationMimeTypesEnum.GIF) &&
                            <CardMedia
                                component="img"
                                height="140"
                                image={getAttachmentUrl(value.base64Data, value.thumbnailUrl)}
                                alt={value.description}
                                onClick={() => {
                                    onAction && onAction(FormAttachmentActionCardEnum.View, index, value);
                                }}
                                sx={{
                                    cursor: "zoom-in"
                                }}
                            />
                        }

                        <FormInput
                            sx={{
                                width: 1,
                                marginTop: 1
                            }}
                            readOnly={readOnly}
                            disabled={disabled}
                            label="Description"
                            name={`${name}.description`}
                        />

                        {!disabled && <CardActions sx={{justifyContent: 'flex-end'}}>


                            <Button size="small" onClick={() => {onAction && onAction(FormAttachmentActionCardEnum.Download, index, value)}}>
                                {t('buttons.download')}
                            </Button>

                            <Button size="small" onClick={() => {onAction && onAction(FormAttachmentActionCardEnum.Delete, index, value)}}>
                                {t('buttons.delete')}
                            </Button>

                            {/* <IconButton
                                sx={{
                                    marginLeft: "auto"
                                }}
                                onClick={() => {
                                    onAction && onAction(FormAttachmentActionCardEnum.Download, index, value);
                                }}
                            >
                                <Download />
                            </IconButton>
                            <IconButton onClick={() => {
                                onAction && onAction(FormAttachmentActionCardEnum.Delete, index, value);
                            }} >
                                <Delete />
                            </IconButton> */}
                        </CardActions>}
                    </Card>
                )
            }
        />
    );
}
